import * as React from "react";
import { Query, QueryResult } from "react-apollo";
import { ALL_USERS_QUERY } from "./queries";
import { AllUsersQuery } from "../../__generated__/types";

class UsersQuery extends Query<AllUsersQuery> {}

interface Props {
  children(props: QueryResult<AllUsersQuery>): React.ReactNode;
}

export default ({ children }: Props) => {
  return (
    <UsersQuery query={ALL_USERS_QUERY}>
      {result => children(result)}
    </UsersQuery>
  );
};



// WEBPACK FOOTER //
// ./src/queries/UsersQuery/UsersQuery.tsx